import { EventTimeService } from './../../../../services/event.time.service';
import { Component, Input, OnInit, ViewEncapsulation } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { ButtonTriggerEvent } from '../../../../common/components';
import { BaseComponent } from '../../../../common/components/base.component';
import { ModalService } from '../../../../common/services/modal.service';
import { EditorChoiceDataSource, HubEvent } from '../../../../models/hub/hub.event';
import { ImageService } from '../../../../services/image.service';
import { SeoService } from '../../../../services/seo.service';
import { EditorChoiceStore } from '../../../../stores/hub.calendar.store';
import { EventDetailsModalComponent } from '../../event.details.modal/event.details.modal.component';
import { EventDetailsModalActions } from '../../event.details.modal/event.details.modal.provider';
import { TripDetailModalComponent } from '../../trip/trip.detail.modal/trip.detail.modal.component';
import { TripDetailModalActions, TripDetailModalData } from '../../trip/trip.detail.modal/trip.detail.modal.provider';

@Component({
  selector: 'ig-visitor-event-card',
  templateUrl: './visitor.event.card.component.html',
  styleUrls: ['./visitor.event.card.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class VisitorEventCardComponent extends BaseComponent implements OnInit {
  @Input() public event: HubEvent;

  public hubName: string;
  public editorChoiceText = '';

  constructor(
    private router: Router,
    public modalService: ModalService,
    public editorChoiceStore: EditorChoiceStore,
    public imageService: ImageService,
    private activatedRoute: ActivatedRoute
  ) {
    super({activatedRoute});
  }

  public ngOnInit() {
    let {hubName} = this.allRouteParams;
    this.hubName = hubName;
    this.editorChoiceTextHandler();
  }

  public editorChoiceTextHandler() {
    this.editorChoiceStore.infoCommand
      .takeUntil(this.isDestroyed)
      .subscribe((editorChoice: EditorChoiceDataSource) => {
        if (!!this.event.startTime) {
          this.editorChoiceText = editorChoice.editorChoiceForEvent;
        } else {
          this.editorChoiceText = editorChoice.editorChoiceForPlace;
        }
      });
  }

  public enterItemByKeyboard($event) {
    if ($event && $event.key === 'Enter') {
      this.showDetails();
    }
  }

  public showDetails() {
    if (this.event.isPromotionImage) {
      window.open(this.event.promotionLink, '_blank');
      return;
    }
    if (!this.isMobile) {
      this.event.hubName = this.hubName;
      let actions = <EventDetailsModalActions>{
        confirm: (event: ButtonTriggerEvent, data: any) => {
        },
      };

      this.modalService.show({
        component: EventDetailsModalComponent,
        providers: [
          {provide: EventDetailsModalActions, useValue: actions},
          {provide: HubEvent, useValue: this.event},
        ],
        panelClass: 'modal-fixed-top-lower',
      });
    } else {
      this.showDetailModalForMobile(this.event, 'event');
    }
  }

  public showDetailModalForMobile(item: any, displayingOn: string, isShowAddToTripBtn = false, index?: number) {
    let actions = <TripDetailModalActions>{
      confirm: (event: ButtonTriggerEvent) => {
      },
    };
    this.modalService.show({
      component: TripDetailModalComponent,
      providers: [
        {provide: TripDetailModalActions, useValue: actions},
        {
          provide: TripDetailModalData,
          useValue: new TripDetailModalData(
            item,
            displayingOn,
            this.hubName,
            null,
            null,
            isShowAddToTripBtn,
            index
          ),
        },
      ],
      panelClass: ['width-modal-100p', 'ig-trip-info-modal'],
    });
  }
}



// WEBPACK FOOTER //
// D:/Work/Development/ImGoing/IMGoing/web/src/components/visitor/calendar/event.card/visitor.event.card.component.ts